import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { AuthNoticeService, AuthService, Login, User, UserLoaded } from '../../../../../../../core/auth';
import { AppState } from '../../../../../../../core/reducers';
import { RoleService } from '../../../../../../management/shared/services/roleService';
import { SharedObject } from '../../../../../../management/shared/sharedObject';
import { ConfirmOtpBindingModel } from '../../../../models/confirmOtpBindingModel';
import { ConfirmPasswordValidator } from '../../../../../../management/shared/validators/confirm-password.validator';
import { ForgetPasswordModel } from '../../../../../../../core/auth/_models/forgetPasswordModel';
import { ResetPasswordModel } from '../../../../../../../core/auth/_models/resetPasswordModel';
import { CommonService } from '../../../../../../management/shared/services/common.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  enterNewPasswordForm: FormGroup;
  inputCount: number = 5;
  level: number = 0;
  istoch = false;
  isLoading: boolean = false;
  phonenumber: string;
  @ViewChild('mobileNumber') mobileNumberInput!: ElementRef;
  @ViewChild('password') passwordInput!: ElementRef;
  ngAfterViewInit(): void {
    //Ensure that the view is fully initialized before focusing
    setTimeout(() => {
      if (this.mobileNumberInput && this.mobileNumberInput.nativeElement)
        this.mobileNumberInput.nativeElement.focus();
    }, 0);
  }

  constructor(private fb: FormBuilder,
    private authNoticeService: AuthNoticeService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private roleService: RoleService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private authOld: AuthService,
    private commonService: CommonService

  ) { }


  ngOnInit() {
    this.authNoticeService.setNotice(null);
    this.forgotPasswordForm = this.fb.group({
      mobileNumber: [null, Validators.compose([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
        Validators.pattern(SharedObject.MobilePattern)
      ])
      ]
    });
    //-----------------------------------------------------------------------------------
    this.enterNewPasswordForm = this.fb.group({
      password: ['', Validators.compose([
        Validators.required,
        Validators.pattern(SharedObject.PasswordPattern)
      ])
      ],
      confirmPassword: ['', Validators.compose([
        Validators.required,
        Validators.pattern(SharedObject.PasswordPattern)
      ])
      ]
    }, {
      validator: ConfirmPasswordValidator.MatchPassword
    });


  }

  formatPhoneNumber(event: Event): void {
    this.istoch = true;
    const input = event.target as HTMLInputElement;
    let inputValue = input.value.replace(/\D/g, ''); // حذف تمامی کاراکترهای غیر عددی

    // هندل کردن هر موقع که کاربر کاراکتر فاصله وارد کند
    if (inputValue.length > 4) {
      inputValue = inputValue.slice(0, 4) + ' ' + inputValue.slice(4);
    }
    if (inputValue.length > 8) {
      inputValue = inputValue.slice(0, 8) + ' ' + inputValue.slice(8);
    }
    // بروز رسانی مقدار input
    input.value = inputValue;
  }

  optimizePhoneNumber(value: string): string {
    if (!value) return value;
    value = value.replace(/\s+/g, '');
    //if (value)
    //value = value.FaToEnDigits();
    return value;
  }

  validationPhonenumber(value: string): boolean {
    value = this.optimizePhoneNumber(value);
    if (!value) return false;
    return Boolean(value.match(SharedObject.MobilePattern));
  }

  validationPassword(value: string): boolean {
    return Boolean(value.match(SharedObject.PasswordPattern));
  }

  getCodeForResetPassword() {
    this.phonenumber = this.optimizePhoneNumber(this.forgotPasswordForm.controls['mobileNumber'].value.toString());
    if (!this.validationPhonenumber(this.phonenumber)) return;

    this.isLoading = true;
    const model: ForgetPasswordModel = new ForgetPasswordModel();
    model.userName = this.faToEnDigits(this.phonenumber);
    this.authOld.forgetPassword(model).subscribe(res => {
      this.level++;
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      this.authNoticeService.setNotice('  خطا ' + err.error.result, "danger");
      this.cdr.markForCheck();
    }, () => {
      this.isLoading = false;
      this.cdr.markForCheck();
    })
  }


  loginCode: string = null;
  getCode(code: string) {
    this.loginCode = code.toString();
  }


  faToEnDigits(text: string): string {
    return text.replace('۰', '0')
      .replace('۱', '1')
      .replace('۲', '2')
      .replace('۳', '3')
      .replace('۴', '4')
      .replace('۵', '5')
      .replace('۶', '6')
      .replace('۷', '7')
      .replace('۸', '8')
      .replace('۹', '9');
  }

  backToFirst() {
    this.istoch = false;
    this.isLoading = false;
    this.cdr.markForCheck();
  }

  goLoginWithOtp() {
    this.router.navigate(['auth/login']);
  }

  showPassword: boolean = false;
  showPasswordConfirm: boolean = false;
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordConfirmVisibility() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  ressetPassword() {
    this.router.navigate(['auth/login/password/forgot']);
  }



  confirmAndLogin() {
    //-------------------------------------------------------------------------
    const controls = this.enterNewPasswordForm.controls;
    /** check form */
    if (this.enterNewPasswordForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.isLoading = true;
    const model: ResetPasswordModel = new ResetPasswordModel();
    model.phoneNumber = this.phonenumber;
    model.code = this.loginCode;
    model.password = this.faToEnDigits(controls['password'].value);
    this.authOld.resetPassword(model).subscribe(res => {
      this.authNoticeService.setNotice("رمز عبور شما با موفقیت تغییر یافت", "success");
      this.commonService.showToast("رمز عبور شما با موفقیت تغییر یافت");
      this.router.navigateByUrl("/auth/login/password");
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      this.authNoticeService.setNotice('  خطا ' + err.error.result, "danger");
      this.cdr.markForCheck();
    }, () => {
      this.isLoading = false;
      this.cdr.markForCheck();
    })

  }


}
